import { useState } from 'react';
import { IntakeForm } from './components/IntakeForm';
import { ReportViewer } from './components/ReportViewer';
import './components/IntakeForm.css';
import './components/ReportViewer.css';

type AppView = { screen: 'intake' } | { screen: 'report'; jobId: string };

export default function App() {
  const [view, setView] = useState<AppView>({ screen: 'intake' });

  if (view.screen === 'report') {
    return (
      <ReportViewer
        jobId={view.jobId}
        onNew={() => setView({ screen: 'intake' })}
      />
    );
  }

  return (
    <IntakeForm
      onComplete={(jobId) => setView({ screen: 'report', jobId })}
    />
  );
}
